import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSecurityData } from '../hooks/useSecurityData';
import SecurityTabs from '../components/security/SecurityTabs';
import DnssecTab from '../components/security/DnssecTab';
import SecurityTab from '../components/security/SecurityTab';
import ApiKeysTab from '../components/security/ApiKeysTab';

const Security: React.FC = () => {
  const [activeTab, setActiveTab] = useState('dnssec');
  const [showApiKey, setShowApiKey] = useState(false);
  
  const {
    dnssecSettings,
    setDnssecSettings,
    securitySettings,
    setSecuritySettings,
    zones,
    loading,
    saveDnssecSettings,
    saveSecuritySettings,
    handleDnssecToggle,
    generateApiKey,
  } = useSecurityData();

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dnssec':
        return (
          <DnssecTab
            dnssecSettings={dnssecSettings}
            setDnssecSettings={setDnssecSettings}
            zones={zones}
            loading={loading}
            onDnssecToggle={handleDnssecToggle}
            onSaveSettings={saveDnssecSettings}
          />
        );
      case 'security':
        return (
          <SecurityTab
            securitySettings={securitySettings}
            setSecuritySettings={setSecuritySettings}
            onSaveSettings={saveSecuritySettings}
            loading={loading}
          />
        );
      case 'keys':
        return (
          <ApiKeysTab
            showApiKey={showApiKey}
            setShowApiKey={setShowApiKey}
            onGenerateApiKey={generateApiKey}
            loading={loading}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">Security</h1>
        <p className="mt-2 text-slate-600 dark:text-slate-400">
          Manage DNSSEC, security settings, and API access
        </p>
      </div>

      {/* Security Content */}
      <div className="bg-white dark:bg-slate-800 shadow-sm rounded-lg">
        <div className="grid grid-cols-1 lg:grid-cols-4">
          {/* Sidebar */}
          <div className="lg:col-span-1 bg-slate-50 dark:bg-slate-900/50 rounded-l-lg">
            <SecurityTabs activeTab={activeTab} onTabChange={setActiveTab} />
          </div>

          {/* Content */}
          <div className="lg:col-span-3 p-6">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.2 }}
              >
                {renderTabContent()}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
